// initial state
const state = () => ({
  validateResponse: [],
  errorMessages   : [],
});

// getters
const getters = {
  validateResponse: (state) => {
    return state.validateResponse;
  },
  errorMessages   : (state) => {
    return state.errorMessages;
  },
};

// actions
const actions = {
  saveValidateResponse({commit}, validateResponse) {
    commit('setValidateResponse', validateResponse);
  },
  saveErrorMessages({commit}, errorMessages) {
    commit('setErrorMessages', errorMessages);
  },
};

// mutations
const mutations = {
  setValidateResponse(state, validateResponse) {
    state.validateResponse = validateResponse;
  },
  setErrorMessages(state, errorMessages) {
    state.errorMessages = errorMessages;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
